module.exports = __webpack_public_path__ + "static/withfriends-automated-member-tiers-a222761d2489ed0a35359c5e36ea32dd.mp4";